module.exports = __webpack_public_path__ + "img/face_shape_male_average.64c476a2.png";